import Model from 'etap/admin/classes/models/model';


class AppointmentOption extends Model {

    defaults() {
        return {
            id: null,
            appointment_id: null,
            appointment_option_at: null,
        }
    }

    casts() {
        return {
            created_at: this.parseDate,
            updated_at: this.parseDate
        }
    }

}

export default AppointmentOption;
